export const styles = {
  button: {
    margin: 1,
    bgcolor: "primary.light",
    color: "secondary.dark",
    "&:hover": {
      bgcolor: "primary.main",
    },
  },

  highlighedMenu: {
    bgcolor: "secondary.light",
    borderRadius: "5%",
  },

  menuList: {
    borderRadius: "50%",
  },
};
